import { baseService } from './baseService'
import Response from '../data/entity/response_entity'
import { STATUS_CODE } from '../data/system_settings'
import { PAGE_SIZE } from '../data/queryFactories'

const handleError = (error) => {
  let message = 'Lỗi không xác định'

  if (error.response) {
    const { status, data } = error.response

    // Determine error message based on status code
    switch (status) {
      case STATUS_CODE.NOT_FOUND:
        message = 'Không tìm thấy thông tin báo cáo lỗi'
        break
      case STATUS_CODE.SERVER_ERROR:
        message = 'Mất kết nối với máy chủ, hãy thử lại'
        break
      case STATUS_CODE.BAD_REQUEST:
        message = 'Bạn không có quyền truy cập, hãy liên hệ với admin'
        break
      case STATUS_CODE.TOO_MANY_REQUEST:
        message = 'Quá nhiều request'
        break
      default:
        message = data?.error || error.message || message
    }

  }

  return Response({
    success: false,
    message: { content: message },
  })
}

export class ErrorService extends baseService {
  async getByUuid(uuid) {
    if (typeof uuid !== 'string') {
      return Response({
        success: false,
        message: {
          content: 'Kiểu dữ liệu không hợp lệ, vui lòng liên hệ Admin',
        },
      })
    }

    try {
      const res = await this.get(`issue?uuid=${uuid}`)
      return Response({
        success: true,
        message: { content: res.data.data },
      })
    } catch (error) {
      return handleError(error)
    }
  }

  async refuseByUuid(uuid) {
    if (typeof uuid !== 'string') {
      return Response({
        success: false,
        message: {
          content: 'Kiểu dữ liệu không hợp lệ, vui lòng liên hệ Admin',
        },
      })
    }

    try {
      const res = await this.post(`issue/${uuid}/refuse`)
      return Response({
        success: true,
        message: { content: res.data.data },
      })
    } catch (error) {
      return handleError(error)
    }
  }

  async search(payloads) {
    try {
      const payload = {
        pageSize: payloads?.pageSize ?? PAGE_SIZE,
        pageNumber: payloads?.pageNumber ?? 0,
        keyword: payloads?.keywords ?? '',
      }

      const res = await this.post('issue/all', payload)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: {
            content: res.data.data,
          },
        })
      }
    } catch (error) {
      return Response({
        success: false,
        message: {
          content: 'Lỗi không xác định',
        },
      })
    }
  }
}

export const errorService = new ErrorService()
